import { MapPin } from 'lucide-react';
import './Coverage.css';

const Coverage = () => (
  <section id="coverage" className="section coverage-section" aria-labelledby="coverage-title">
    <span className="section-eyebrow">Zone d'intervention</span>
    <h2 id="coverage-title" className="section-title">
      Nous créons votre site partout en <em>France</em>.
    </h2>
    <p className="section-desc">
      Webdream.fr accompagne les entreprises, artisans et indépendants dans toute la France métropolitaine et l'outre-mer. Tout se fait à distance — un simple appel visio suffit pour lancer votre projet, où que vous soyez.
    </p>

    <div className="coverage-highlight">
      <div className="coverage-flag">
        <MapPin size={22} strokeWidth={1.8} />
      </div>
      <div>
        <div className="coverage-highlight-title">France entière</div>
        <div className="coverage-highlight-sub">Intervention 100 % à distance · Devis gratuit sous 24h</div>
      </div>
    </div>
  </section>
);

export default Coverage;
